/* eslint-disable no-nested-ternary */
import * as React from "react";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { TableContainer } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

function EnhancedTableHead(props) {
  const { tableheadCells } = props;

  return (
    <TableHead sx={{ background: "white", marginBottom: "12px", borderRadius: "12px" }}>
      <TableRow>
        {tableheadCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
            className="targetLastChild"
            sx={{
              padding: "16px 18px",
              fontSize: "13px",
              fontFamily: "Poppins-SemiBold",
              color: "var(--color-primitives-primary-900)",
              "& .MuiTableSortLabel-icon": {
                color: "var(--color-primitives-primary-600) !important",
                borderRadius: "10px",
                backgroundColor: "#F4F4F4",
              },
              borderRight: "1px solid var(--color-primitives-primary-100)",
            }}
          >
            <Typography variant="h5">{headCell.label}</Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function DataTableV2(props) {
  const {
    handleRequestSortBy,
    totalCount,
    rowsData,
    tableheadCells,
    handleRowsPerPage,
    handleSelectedRow,
    sortByName,
    openDetailsPage,
    minimumHeight,
    tableHeader,
    tableRowContent,
    resetPage,
  } = props;

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [selected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [, setHeaders] = React.useState([]);
  const [rowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    const direction = isAsc ? "desc" : "asc";

    const sortRequest = {
      orderBy: property,
      order: direction,
    };
    setOrder(direction);
    setOrderBy(property);
    handleRequestSortBy(sortRequest);
  };

  const handleRowSelected = (id) => {
    if (id) {
      handleSelectedRow(id, "details");
    }

    // setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // methods

  React.useEffect(() => {
    //
    setOrderBy(sortByName);
  }, [sortByName]);

  React.useEffect(() => {
    if (rowsData.length && rowsData != undefined && rowsData != null) setHeaders(Object.keys(rowsData[0]));
  }, [rowsData]);

  React.useEffect(() => {
    if (resetPage) {
      setPage(0);
    }
  }, [resetPage, totalCount]);

  React.useEffect(() => {
    if (handleRowsPerPage) handleRowsPerPage({ rowsPerPage, page });
  }, [rowsPerPage, page]);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          overflowX: "hidden",
          width: "100%",
          mb: 2,
          pt: "0.2rem",
          borderRadius: "5px !important",
          background: "transparent",
          boxShadow: "none !important",
        }}
      >
        <TableContainer
          sx={{
            p: "12px 0px",
            minHeight: minimumHeight != false ? (rowsData.length < 3 ? 470 : 150) : 150,
            maxHeight:
              window.screen.width < 1600
                ? "32rem"
                : window.screen.width >= 1600 && window.screen.width < 1900
                  ? "40rem"
                  : "46rem",
          }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "none",
              },
            }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            {tableHeader != false ? (
              <EnhancedTableHead
                order={order}
                tableheadCells={tableheadCells}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rowsData.length}
              />
            ) : null}
            <Box sx={{ height: "12px" }} />
            <TableBody sx={{ background: "white", overflowY: "scroll" }}>
              {rowsData.map((row, index) => {
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover={!!handleSelectedRow}
                    textAlign="start"
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={labelId}
                    selected={isItemSelected}
                    sx={{
                      "&.MuiTableRow-root": {
                        verticalAlign: tableRowContent ? "top !important" : "center !important",
                      },
                    }}
                  >
                    {tableheadCells.map((header) => {
                      return (
                        <TableCell
                          className="targetLastChild"
                          key={header.id}
                          sx={{
                            whiteSpace: header?.wrapCell && "normal",
                            wordBreak: header?.wrapCell && "break-word",
                            cursor: header.id == openDetailsPage && "pointer",
                            borderRight: "1px solid var(--color-primitives-primary-50)",
                          }}
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="dense"
                          align={header.align ? header.align : "left"}
                          width={header.width ? header.width : "auto"}
                          onClick={() => {
                            if (header.id == openDetailsPage) handleRowSelected(row.id);
                          }}
                        >
                          {row[header.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
